/**
 * Banner + bar informasi ESA OFFICE — tidak saling timpang tindih (alur vertikal)
 */

import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

import burceMars from "assets/images/bruce-mars.jpg";
import eoCover from "assets/images/eo_cover.png";
import eoCover2 from "assets/images/eocover2.png";
import eoCover3 from "assets/images/eocover3.png";
import eoCover4 from "assets/images/eocover4.png";
import eo_mini1 from "assets/images/eo_mini1.png";
import eo_mini4 from "assets/images/eo_mini4.png";

function Header({ children = "", profile }) {
  const theme = useTheme();
  const [isMobile, setIsMobile] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const coverImagesDesktop = [eoCover, eoCover2, eoCover3, eoCover4];
  const coverImagesMobile = [eo_mini1, eo_mini4];
  const coverImages = isMobile ? coverImagesMobile : coverImagesDesktop;

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 960);
      setCurrentImageIndex(0);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    const n = coverImages.length;
    const interval = setInterval(() => {
      setCurrentImageIndex((i) => (i + 1) % n);
    }, 4000);
    return () => clearInterval(interval);
  }, [isMobile]);

  return (
    <MDBox mb={3} px={{ xs: 2, md: 3 }}>
      {/* Banner — blok sendiri, tidak ditindih kartu */}
      <MDBox
        sx={{
          position: "relative",
          width: "100%",
          height: { xs: 112, md: 132 },
          overflow: "hidden",
          borderRadius: 2,
          border: "1px solid",
          borderColor: "grey.200",
          bgcolor: "grey.100",
        }}
      >
        <MDBox
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: 3,
            zIndex: 2,
            background: `linear-gradient(90deg, ${theme.palette.info.main} 0%, ${theme.palette.success.main} 50%, ${theme.palette.error.main} 100%)`,
          }}
        />
        {coverImages.map((image, index) => (
          <MDBox
            key={index}
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              opacity: index === currentImageIndex ? 1 : 0,
              transition: "opacity 1s ease-in-out",
            }}
          >
            <img
              src={image}
              alt={`Banner ${index + 1}`}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </MDBox>
        ))}
      </MDBox>

      {/* Jarak jelas antara banner dan kartu logo */}
      <Card
        elevation={0}
        sx={{
          mt: 2,
          py: 1.75,
          px: 2,
          border: "1px solid",
          borderColor: "grey.200",
          borderRadius: 2,
          borderLeft: "4px solid",
          borderLeftColor: "info.main",
          bgcolor: "background.paper",
        }}
      >
        <Grid container spacing={2} alignItems="center" wrap="nowrap">
          <Grid item sx={{ flexShrink: 0 }}>
            <MDAvatar
              src={profile || burceMars}
              alt="ESA Office"
              sx={{
                width: 56,
                height: 56,
                border: "1px solid",
                borderColor: "grey.300",
                boxShadow: "none",
              }}
              onError={(e) => {
                e.target.src = burceMars;
              }}
            />
          </Grid>
          <Grid item xs zeroMinWidth>
            <MDTypography variant="subtitle1" fontWeight="600" color="text">
              ESA OFFICE
            </MDTypography>
            <MDTypography variant="caption" color="text.secondary" display="block">
              Platform kerja digital terintegrasi
            </MDTypography>
          </Grid>
        </Grid>
        {children}
      </Card>
    </MDBox>
  );
}

Header.propTypes = {
  children: PropTypes.node,
  profile: PropTypes.string,
};

export default Header;
